import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/compat/storage';
import { GeneralService } from '../services/general.service';
import { LoaderServiceService } from '../services/loaderService.service';
import { Observable, Subscription } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import * as firebase from 'firebase/app';

import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
} from '@angular/forms';
import { Globals } from 'app/globals';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-assignuserdashboard',
  templateUrl: './assignuserdashboard.component.html',
  styleUrls: ['./assignuserdashboard.component.scss']
})
export class AssignuserdashboardComponent implements OnInit {
  // tslint:disable-next-line:max-line-length

  @ViewChild('UploadFileInput') uploadFileInput: ElementRef;
  myfilename = 'Select File';
  selectedFile: File = null;
  fb;
  @Input() file: File;

  task: AngularFireUploadTask;

  percentage: Observable<number>;
  snapshot: Observable<any>;
  downloadURL: string;
  
  form = {
    comment:'',
  };

  step = 0;
  currentuser: any;
  clientaudit: any[]=[];
  expiredduedate: boolean;
  questions: any[]=[];
  allfiles: FileList;
  fileurl: any;
  element: any;
  imageSrc: string | ArrayBuffer;
  imagePath: any;
  imgURL: any[]=[];
  urls : any[]=[];
  elementimg: any;
  imgs: any[]=[];
  photos: any[]=[];
  finish: boolean;
  assignaudit: any[]=[];
  ActionPlanforedit: any[]=[];
  photosurl: any[]=[];
  assignaudit2: any;
  catindex: number;
  questionindex: number;
  ActionPlan: any[]=[];
  moduleName: any;
  Globals:Globals



  pageSize: number = 10;
  pageNumber: number = 1;
  totalPages: number;
  private subscription: Subscription; // Subscription to Firestore query
  lastDocument: any;
  AssignerImg: any[]=[];
  filesToupload: any[]=[];
  uplodedFiles: any[]=[];
  En: boolean=true;
  assignerimg: any;
  hasMoreData: boolean = true;
  isSubmitting: boolean = false; // Track submission state

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  constructor(private genralservcies:GeneralService,private storage: AngularFireStorage, private loaderService: LoaderServiceService) { }
  deleteimage(imgindex) {
    // Remove the image at the specified index
    this.urls.splice(imgindex, 1);
    // Update elementimg to reflect the current element's images
    this.elementimg = this.urls.filter((x) => x.index == this.element);
  }

  onFileSelected(event: Event, element: number) {
    console.log(element);
    this.element = element;
    const input = event.target as HTMLInputElement;
    const files = input.files;
    this.allfiles = files;
    console.log(files);
  
    if (files && files.length > 0) {
      // Check if adding new files would exceed the limit of 3
      const currentImages = this.urls.filter(x => x.index === element).length;
      const remainingSlots = 3 - currentImages;
      
      if (remainingSlots <= 0) {
        Swal.fire({
          title: 'Warning',
          text: 'Maximum 3 images allowed'
        });
        return;
      }

      // Limit the number of files to process based on remaining slots
      const filesToProcess = Array.from(files).slice(0, remainingSlots);
      
      // Iterate through each selected file
      for (let file of filesToProcess) {
        let reader = new FileReader();
  
        // Define the onload event handler for the FileReader
        reader.onload = (e: ProgressEvent<FileReader>) => {
          // e.target.result contains the base64-encoded image data
          const base64Image = e.target?.result as string;
          console.log(base64Image);
          // Push the base64 image data along with index and file info to urls array
          this.urls.push({ img: base64Image, index: element, file: file });
  
          // Filter the urls array to get images specific to the current element
          this.elementimg = this.urls.filter((x) => x.index == element);
  
          // Update ActionPlan to trigger change detection
          this.ActionPlan = [...this.ActionPlan];
  
          console.log(this.ActionPlan);
        };
        reader.onloadend = (_event) => {
          input.value = '';
        }
  
        // Read the file as a data URL (base64-encoded image)
        reader.readAsDataURL(file);
      }
    }
  
    console.log(this.allfiles);
  }
    
  async uploadPhotos(photos: any): Promise<string[]> {
    const downloadUrls: string[] = [];
if(photos){
  for (const photo of photos) {
    // Create a unique path for each photo
    console.log(photo)
    // const photoPath = `${new Date().getTime()}.jpg`;
    // const ref = this.storage.ref(photoPath);
    // const task = ref.put(photo);
    // var photoPath = `_${new Date().getTime()}.jpg`;
    var photoPath =  `clients/${this.currentuser.clientid}/_${new Date().getTime()}.jpg`;
    const uploadTask = this.storage
      .ref(photoPath)
      .putString(photo.img,"data_url");
    // Wait for the upload task to complete
    await uploadTask.then(async (snapshot) => {
      // Get the download URL of the photo
      const downloadUrl = await snapshot.ref.getDownloadURL();
      downloadUrls.push(downloadUrl);
    });
  }

  return downloadUrls;
}
else{
  return null
}
   
  }
  async updateActionPlan(ActionPlan,Id): Promise<void> {
    // Specify the document to update
    return new Promise<any>((resolve, reject) => {
    this.genralservcies.updateActionPlan(ActionPlan,Id).then(res=>{
      resolve(res);
    }, error => {
      reject(error);
    }).catch(error => {
      // This block is executed if there is an error with the API call
      console.error("API error:", error);
      // Handle the error as needed, e.g., display an error message to the user
    });
    })
  }
  isActive(snapshot) {
    return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes;
  }

  async submit(index){
    // Prevent multiple submissions
    if (this.isSubmitting) {
      return;
    }

    // Check if response comment exists and is not empty
    const hasResponse = this.ActionPlan[index].assigneranswercomment && 
                       this.ActionPlan[index].assigneranswercomment.trim().length > 0;
    
    // Check if there are photos for this specific item
    const itemPhotos = this.urls.filter(x => x.index === index);
    const hasPhotos = itemPhotos && itemPhotos.length > 0;

    if(hasResponse && hasPhotos){
      try {
        // Set loading state and show loader
        this.isSubmitting = true;
        this.loaderService.show();

        const timestamp = Date.now();
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0'); // Ensures day is two digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensures month is two digits (months are zero-based, so add 1)
        const year = date.getFullYear();
        const assigneranswerdate = `${day}-${month}-${year}`;
        
        this.ActionPlan[index].assigneranswerurl=await this.uploadPhotos(this.elementimg);
        this.ActionPlan[index].done='true';
        this.ActionPlan[index].assigneranswerdate=assigneranswerdate
        delete   this.ActionPlan[index].assingerimg
        console.log(this.ActionPlan[index])
        await this.getAuditbyId(this.ActionPlan[index].auditid)

        this.updateActionPlan(this.ActionPlan[index],this.ActionPlan[index].id).then(res=>{
          return new Promise<any>((resolve, reject) => {
            console.log(res,"updateActionPlan")
            this.ActionPlan=this.ActionPlan.filter(x=>x.id!=this.ActionPlan[index].id)
            if(this.ActionPlan.length == 5){
              this.nextPage();
            }
            this.elementimg=[];
            this.assignerimg = null;
            this.urls=[]
            
            // Hide loader and reset submission state
            this.loaderService.hide();
            this.isSubmitting = false;
          }).catch(error => {
            // This block is executed if there is an error with the API call
            console.error("API error:", error);
            // Hide loader and reset submission state on error
            this.loaderService.hide();
            this.isSubmitting = false;
            // Handle the error as needed, e.g., display an error message to the user
          });
        })
      } catch (error) {
        console.error("Submit error:", error);
        // Hide loader and reset submission state on error
        this.loaderService.hide();
        this.isSubmitting = false;
        Swal.fire({
          title: 'Error',
          text: 'An error occurred while submitting. Please try again.',
          icon: 'error'
        });
      }
    }
    else{
      if(!hasResponse){
        Swal.fire({
          title:'Warning',
          text:"Please Enter Your Comment"
        })
      }
      else if(!hasPhotos){
        Swal.fire({
          title:'Warning',
          text:"Please Select At Least 1 Photo"
        })
      }
     
    }

}
async getAuditbyId(auditId){
  
this.genralservcies.getAuditerbyId(auditId).then(res=>{
  console.log(res);
const moduleid=res.module.id;
const branchId=res.branchid
const date = new Date(res.EndDate);
const year = date.getFullYear();
const month = date.getMonth() + 1;
console.log(month)

this.getAnalysisTaskCompilationMonthlyByDate(moduleid,branchId,month,year)
this.getAnalysisTaskCompilationYearlyByDate(moduleid,branchId,year)
})
}
getAnalysisTaskCompilationMonthlyByDate(moduleid,branchId,month,year){
  this.genralservcies.getAnalysisTaskCompilationMonthlyByDate(moduleid,branchId,month,year).then(AnalysisTaskCompilationMonthly=>{
  
   
    AnalysisTaskCompilationMonthly[0].opencount=Number( AnalysisTaskCompilationMonthly[0].opencount) - 1
    AnalysisTaskCompilationMonthly[0].closecount=Number( AnalysisTaskCompilationMonthly[0].closecount) + 1
    AnalysisTaskCompilationMonthly[0].openscore=Math.floor((AnalysisTaskCompilationMonthly[0].opencount *100 ) / ( AnalysisTaskCompilationMonthly[0].totalcount)); 
    AnalysisTaskCompilationMonthly[0].closescore=Math.floor(( AnalysisTaskCompilationMonthly[0].closecount *100 ) / ( AnalysisTaskCompilationMonthly[0].totalcount));

    this.genralservcies.UpdateAnalysisTaskCompilationMonthlyByDate( AnalysisTaskCompilationMonthly[0], AnalysisTaskCompilationMonthly[0].id).then(res=>{
    })
    
    })
}
getAnalysisTaskCompilationYearlyByDate(moduleid,branchId,year){
  this.genralservcies.getAnalysisTaskCompilationYearlyByDate(moduleid,branchId,year).then(AnalysisTaskCompilationYearly=>{
     console.log(AnalysisTaskCompilationYearly);
    AnalysisTaskCompilationYearly[0].opencount=Number(AnalysisTaskCompilationYearly[0].opencount) - 1
    AnalysisTaskCompilationYearly[0].closecount=Number(AnalysisTaskCompilationYearly[0].closecount) + 1
    AnalysisTaskCompilationYearly[0].openscore = Math.floor((AnalysisTaskCompilationYearly[0].opencount *100 ) / (AnalysisTaskCompilationYearly[0].totalcount));
    AnalysisTaskCompilationYearly[0].closescore= Math.floor((AnalysisTaskCompilationYearly[0].closecount *100 ) / (AnalysisTaskCompilationYearly[0].totalcount));
       
    this.genralservcies.UpdateAnalysisTaskCompilationYearlyByDate(AnalysisTaskCompilationYearly[0],AnalysisTaskCompilationYearly[0].id).then(res=>{
    })
    
    })
}
Translate(){
  this.En =!this.En
}
  ngOnInit() {
    this.currentuser=JSON.parse(localStorage.getItem("currentuser"))
    console.log(this.currentuser)
    this.loadPage();
  }
 
  loadPage(){
    this.genralservcies.getActionPlanbyAssignerid(this.currentuser.id,this.pageSize,this.lastDocument,this.pageNumber).subscribe((res:any)=>{
      if (res && res.length > 0) {
        res.forEach(element => {
          this.ActionPlan.push(element);
        });
        // Update lastDocument with the last document fetched
        this.lastDocument = res[res.length - 1];
        // Show button if we got a full page of results
        // this.hasMoreData = res.length >= this.pageSize;
      } else {
        // Hide button if we got no results or less than page size
        this.hasMoreData = false;
      }
      console.log(this.ActionPlan);
    });
  }
  ngOnDestroy() {
    // Unsubscribe from Firestore subscription when component is destroyed
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  nextPage() {
    this.pageNumber++;
    this.loadPage(); // Fetch next page
  }

  openPhoto(url:any) {
    Swal.fire({
      imageUrl: url,
      // imageWidth: 500,
      // imageHeight: 400,
      imageAlt: 'Custom image',
    })
  }
}
